module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/why-pict-4734853b2afa7bd5864d4f74ce3c6c03.jpg";